import {
  Box,
  Divider,
  Menu,
  MenuItem,
  Stack,
  Tooltip as Tp,
  Button as MuiButton,
} from "@mui/material";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";

//css
import "./GuestCards.css";

// img
import mailIcon from "../../../../assets/svg/contact/ic-mail.svg";
import phoneIcon from "../../../../assets/svg/contact/ic-phone.svg";
import rightArrow from "../../../../assets/svg/arrows/arrow-right-light.svg";
import icPhoto from "../../../../assets/svg/action/ic-photo-white.svg";
import icCross from "../../../../assets/svg/action/ic-cross-white.svg";
import icCorrect from "../../../../assets/svg/action/ic-correct-white.svg";
import icPen from "../../../../assets/svg/action/ic-edit-pen-white.svg";
import avatar from "../../../../assets/png/avatarProfile.png";
import brokenImg from "../../../../assets/png/brokenImg.png";
import {
  addParamsURL,
  capitalizeWords,
  getLocalDate,
  isoToInformalData,
  getLocalTime,
} from "../../../../util/helper";
import React, { useState } from "react";
import decryptUrl from "../../../../util/img-decryption";
import {
  Button,
  Container,
  Icon,
  InputCheckbox,
  Text,
  Tooltip,
} from "@jds/core";
import GuestDetailDrawer from "./GuestDetailDrawer";
import GuestQuickActions from "./GuestQuickActions";

const customFieldsShow = (customFields, field) => {
  if (
    customFields?.[field?.id]?.type === "text" ||
    customFields?.[field?.id]?.type === "dropdown" ||
    customFields?.[field?.id]?.type === "radio" ||
    customFields?.[field?.id]?.type === "date" ||
    customFields?.[field?.id]?.type === "paragraph"
  ) {
    return (
      <>
        <Tooltip
          label={customFields?.[field?.id]?.questionName}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            <b>{customFields?.[field?.id]?.questionName}:</b>
          </p>
        </Tooltip>
        <Tooltip
          label={customFields?.[field?.id]?.questionName + ": " + field?.value}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            {field?.value}
          </p>
        </Tooltip>
      </>
    );
  }
  if (customFields?.[field?.id]?.type === "consent") {
    return (
      <>
        <Tooltip
          label={customFields?.[field?.id]?.questionName}
          position="bottom"
        >
          <Container gap={8}>
            <InputCheckbox checked={field?.value} disabled />
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "220px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {customFields?.[field?.id]?.questionName}
            </p>
          </Container>
        </Tooltip>
      </>
    );
  }
  if (customFields?.[field?.id]?.type === "checkbox") {
    return (
      <>
        <Tooltip
          label={customFields?.[field?.id]?.questionName}
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            <b>{customFields?.[field?.id]?.questionName}:</b>
          </p>
        </Tooltip>
        <Tooltip
          label={
            customFields?.[field?.id]?.questionName +
            ": " +
            field?.value?.map((val, index) =>
              index + 1 !== field?.value?.length ? val + "" : val,
            )
          }
          position="bottom"
        >
          <p
            style={{
              whiteSpace: "nowrap",
              maxWidth: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {field?.value?.map((val, index) =>
              index + 1 !== field?.value?.length ? val + ", " : val + ".",
            )}
          </p>
        </Tooltip>
      </>
    );
  }
};

const InvitedGuests = ({
  guest,
  hasCustomField = false,
  setContactInfoModalClose = () => { },
  loadContactInfo,
  contactInfo = {},
  isContactInfoLoading = false,
  setIsEditGuestModalClose = () => { },
  setBlockModalClose = () => { },
  setIsFaceModalClose = () => { },
  setSecondaryProfileModalClose = () => { },
  customFields = {},
  onReminderClick = () => { },
  isReminderLoading = false,
  showQuickTiming = false,
}) => {
  const [errorImg, setErrorImg] = useState(false);
  const [detailDrawerOpen, setDetailDrawerOpen] = useState(false);
  console.log(hasCustomField, "custom data123", guest);
  console.log(guest?.createdAt);
  console.log(getLocalDate(guest?.createdAt));

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <div
        style={{
          borderRadius: "24px",
          boxShadow: " 0px 4px 16px 0px #00000014",
          height: "100%",
          position: "relative",
        }}
      >
        {/* Kebab menu */}
        <Box sx={{ display: "none", position: "absolute", top: "16px", right: "16px" }}>
          <Icon ic={"IcMoreVertical"} color="grey-80" onClick={handleMenuClick} />
          <Menu
            id="guest-card-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                "aria-labelledby": "guest-card-menu-button",
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              "& p": {
                fontFamily: "var(--font-families-body-s)",
                fontSize: "var(--font-sizes-body-s)",
                fontWeight: "var(--font-weights-body-s)",
                color: "var(--color-primary-grey-100)",
                lineHeight: "var(--line-heights-body-s)",
                letterSpacing: "var(--letter-spacing-body-s)",
              },
            }}
          >
            {guest?.userId ? (
              <MenuItem
                onClick={() => {
                  setBlockModalClose();
                  handleClose();
                }}
              >
                <p>Block</p>
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  setIsEditGuestModalClose();
                  handleClose();
                }}
              >
                <p>Edit</p>
              </MenuItem>
            )}
          </Menu>
        </Box>

        {/* ======= Top div with profile info ========== */}
        <Box p={3}>
          <GuestQuickActions
            onEdit={setIsEditGuestModalClose}
            onBlock={guest?.userId ? setBlockModalClose : undefined}
          />

          {/* Profile info */}
          <Stack
            direction="row"
            alignItems="center"
            gap={2}
            mb={2}
            sx={{ "& .j-JDSImage-image": { height: "100%" } }}
          >
            <div style={{ position: "relative" }}>
              <img
                src={
                  errorImg
                    ? brokenImg
                    : guest?.profileFile
                      ? URL.createObjectURL(guest?.profileFile)
                      : guest?.profilePictureThumbnailUrl
                        ? // ? decryptUrl(guest?.profilePictureThumbnailUrl)
                        addParamsURL(guest?.profilePictureThumbnailUrl, {
                          size: "s",
                        })
                        : avatar
                }
                onClick={() => {
                  if (guest?.profilePictureThumbnailUrl) {
                    setIsFaceModalClose();
                  }
                }}
                style={{
                  width: "84px",
                  height: "84px",
                  borderRadius: "50%",
                  objectPosition: "center",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                onError={() => {
                  setErrorImg(true);
                }}
              />
              <Tp
                title="Invited guest"
                arrow
                placement="bottom"
                slotProps={{
                  tooltip: {
                    sx: {
                      fontSize: "14px",
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    bottom: "4px",
                    right: "0",
                    borderRadius: "50%",
                    aspectRatio: 1,
                    backgroundColor: "white",
                    padding: "1px",
                  }}
                >
                  <Icon ic={"IcMail"} color="primary" />
                </Box>
              </Tp>
              {/* secondary profile indicator */}
              {guest?.secondaryProfilesCount > 0 && (
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  className="secondary-profile-indicator"
                  sx={{
                    position: "absolute",
                    top: "-10px",
                    left: "-10px",
                  }}
                >
                  <Icon ic={"IcProfile"} size="s" color="white" />
                  <p>{guest?.secondaryProfilesCount}</p>
                </Stack>
              )}
            </div>
            <Stack direction="column" gap={"3px"}>
              <Tp
                title={`${guest?.firstName || "User"} ${guest?.lastName || ""} `}
                arrow
                position="bottom"
              >
                {" "}
                <p className="name-overflow">
                  {`${guest?.firstName || "User"} ${guest?.lastName || ""} `}
                </p>
              </Tp>
              {!guest?.viewingStatus?.myPhotos?.visited ? (
                <Stack direction={"row"} gap={0.5} alignItems={"start"}>
                  <Icon ic={"IcVisible"} color="grey-60" size="s" />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "var(--color-primary-grey-80)",
                      maxWidth: "88%",
                    }}
                  >
                    Not yet visited
                  </p>
                </Stack>
              ) : (
                <Box
                  sx={{
                    "--color-primary-50": guest?.viewingStatus?.myPhotos
                      ?.hasPhotos
                      ? "#25ab21"
                      : "#ffd947ff",
                  }}
                >
                  <Stack direction={"row"} gap={0.5} alignItems={"start"}>
                    <Icon ic={"IcVisible"} size="s" />
                    <p
                      style={{
                        fontSize: "12px",
                        color: "var(--color-primary-grey-80)",
                        maxWidth: "88%",
                      }}
                    >
                      {guest?.viewingStatus?.myPhotos?.hasPhotos
                        ? "Visited and viewed photos"
                        : "Visited, but no photos were available at that time"}
                    </p>
                  </Stack>
                </Box>
              )}
              {/* {guest?.secondaryProfilesCount > 0 &&
              <Stack
                className="secondary-profile-btn"
                direction="row"
                alignItems="center"
                sx={{ '&, a': { color: 'var(--color-primary-50)' } }}
                onClick={() => setSecondaryProfileModalClose(guest?.userId)}
              >
                <Stack direction={'row'} gap={'3px'} alignItems={'center'}>
                  <GroupOutlinedIcon color="inherit" />
                  <a>{guest?.secondaryProfilesCount} secondary profile{guest?.secondaryProfilesCount > 1 ? 's' : ""}</a>
                </Stack>
                <ChevronRightOutlinedIcon color="inherit" />
              </Stack>
            } */}
            </Stack>
          </Stack>

          {/* Contact info */}
          <Stack
            direction="row"
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexDirection: "column",
                marginTop: "8px",
              }}
            >
              {guest.email && (
                <p
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={mailIcon}
                    style={{
                      width: "24px",
                    }}
                  />
                  {guest.email}
                </p>
              )}
              {guest.phoneNumber && (
                <p
                  style={{
                    fontSize: "16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img
                    src={phoneIcon}
                    style={{
                      width: "24px",
                    }}
                  />
                  <p>{guest?.phoneNumber}</p>
                </p>
              )}
            </div>
            <Button
              label="View"
              kind="tertiary"
              size="m"
              onClick={() => {
                setContactInfoModalClose(guest?.id);
              }}
            />
          </Stack>

          <Box mt={3}>
            <Divider />
          </Box>
        </Box>

        {/* ======= Access permission info ========== */}
        <Box px={3}>
          <p className="name-overflow">Image Access</p>
          <div
            style={{
              display: "flex",
              gap: "8px",
              margin: "12px 0",
              flexWrap: "wrap",
            }}
          >
            <p
              style={{
                backgroundColor: "var(--color-primary-50)",
                fontSize: "12px",
                fontWeight: "700",
                color: "#ffff",
                height: "fitContent",
                width: "fitContent",
                padding: "2px 6px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                src={icPhoto}
                style={{
                  width: "16px",
                }}
              />
              {guest?.access ? capitalizeWords(guest?.access, "_") : "No Access"}
            </p>
            <p
              style={{
                backgroundColor:
                  guest?.uploadAccess == "APPROVED"
                    ? "var(--color-feedback-success-50)"
                    : "var(--color-feedback-error-50)",
                fontSize: "12px",
                fontWeight: "700",
                color: "#ffff",
                height: "fitContent",
                width: "fitContent",
                padding: "2px 6px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                src={guest?.uploadAccess == "APPROVED" ? icCorrect : icCross}
                style={{
                  width: "16px",
                }}
              />{" "}
              Upload Access
            </p>
            <p
              style={{
                backgroundColor:
                  guest?.downloadAccess == "APPROVED"
                    ? "var(--color-feedback-success-50)"
                    : "var(--color-feedback-error-50)",
                fontSize: "12px",
                fontWeight: "700",
                color: "#ffff",
                height: "fitContent",
                width: "fitContent",
                padding: "2px 6px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                src={guest?.downloadAccess == "APPROVED" ? icCorrect : icCross}
                style={{
                  width: "16px",
                }}
              />{" "}
              Download Access
            </p>
          </div>
          <Box mt={3}>
            <Divider />
          </Box>
        </Box>

        {/* ======= Date & Time ========== */}
        {showQuickTiming && <Box p={3}>
          <Stack direction="row" gap={1} alignItems="center">
            <Icon ic={"IcCalendar"} color="grey-80" size="s" />
            <Text
              text={`Invited date : ${getLocalDate(guest?.createdAt)}`}
              appearance="body-s"
            />
          </Stack>
          <Stack direction="row" gap={1} alignItems="center">
            <Icon ic={"IcTime"} color="grey-80" size="s" />
            <Text
              text={`Invited time : ${getLocalTime(guest?.createdAt)}`}
              appearance="body-s"
            />
          </Stack>
        </Box>}

        {/* ============== Custom field ============== */}
        {false && hasCustomField && (
          <Box
            sx={{
              padding: "16px 24px",
              borderTop: "1px solid #e0e0e0",
            }}
          >
            <>
              {guest?.customField?.length > 0 && (
                <div
                  style={{
                    paddingBottom: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    width: "100%",
                  }}
                >
                  {guest?.customField?.map((item) => {
                    return customFieldsShow(customFields, item);
                  })}
                </div>
              )}
              {!guest?.customField && (
                <div
                  fullWidth
                  style={{
                    // borderTop: "1px solid #e0e0e0",
                    paddingBlock: "16px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p style={{ color: "#D3D3D3" }}>Yet to register</p>
                </div>
              )}
            </>
          </Box>
        )}
        <div className="guest-card-footer-action">
          <MuiButton
            className="guest-more-info-button"
            onClick={() => setDetailDrawerOpen(true)}
          >
            More Info
            <span className="guest-more-info-arrow">
              <Icon ic="IcChevronRight" size="s" />
            </span>
          </MuiButton>
        </div>
      </div>
      <GuestDetailDrawer
        open={detailDrawerOpen}
        onClose={() => setDetailDrawerOpen(false)}
        guest={guest}
        customFields={customFields}
        hasCustomField={hasCustomField}
        loadContactInfo={loadContactInfo}
        contactInfo={contactInfo}
        isContactInfoLoading={isContactInfoLoading}
        setContactInfoModalClose={(id) => {
          setDetailDrawerOpen(false);
          setContactInfoModalClose(id);
        }}
        setIsFaceModalClose={setIsFaceModalClose}
        onReminderClick={onReminderClick}
        isReminderLoading={isReminderLoading}
        onBlock={
          guest?.userId
            ? () => {
              setDetailDrawerOpen(false);
              setBlockModalClose();
            }
            : undefined
        }
        onEdit={() => {
          setDetailDrawerOpen(false);
          setIsEditGuestModalClose();
        }}
      />
    </>
  );
};

export default React.memo(InvitedGuests);
